module.exports = __webpack_public_path__ + "vrplayerstatic/media/gyroOff.cd44ca30.svg";